import { FormLabel } from "@mui/material";
import { styled } from "@mui/system";

const StyledFormLabel = styled(FormLabel)(({ theme }) => ({
  color: '#344054',
  fontWeight: '500',
  lineHeight: '20px',
  textAlign: "left",
}));

export default StyledFormLabel;

